import { render, staticRenderFns } from "./LoginWithSberId.vue?vue&type=template&id=8ef7925e&scoped=true&"
import script from "./LoginWithSberId.vue?vue&type=script&lang=js&"
export * from "./LoginWithSberId.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithSberId.vue?vue&type=style&index=0&id=8ef7925e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef7925e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
